export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20warm%20amber%20and%20golden%20light%20streaks%2C%20soft%20bokeh%20effects%2C%20theater%20curtain%20texture%20in%20deep%20crimson%20and%20charcoal%20tones%2C%20elegant%20movie%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20cinematic%20gradient%20lighting%2C%20luxurious%20dark%20aesthetic&width=1920&height=1080&seq=mahua-hero-bg-01&orientation=landscape"
          alt="麻花影院背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="w-full max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left animate-fade-in">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 text-accent-300 text-xs md:text-sm font-medium mb-5 tracking-wide">
                每日更新 · 高清不卡
              </span>

              <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
                麻花影院 · 免费在线观影平台
              </h1>

              <p className="text-lg md:text-xl text-primary-300 font-medium mb-6">
                海量高清影视，无需付费，随心畅享
              </p>

              <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-8 max-w-xl lg:max-w-none">
                麻花影院汇聚全网最新电影、热播电视剧、热门综艺等海量内容，每日实时更新片源，高清画质流畅不卡顿。无论是最新上映的大片，还是经典怀旧剧集，打开麻花影院免费观看即可畅享沉浸式观影体验，无需注册、无需付费，随时随地看你想看。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
                <div className="flex items-center gap-2 text-background-50/80">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-500/20 rounded-lg">
                    <i className="ri-film-line text-primary-400 text-sm"></i>
                  </div>
                  <span className="text-xs md:text-sm">片源每日更新</span>
                </div>
                <div className="flex items-center gap-2 text-background-50/80">
                  <div className="w-8 h-8 flex items-center justify-center bg-accent-500/20 rounded-lg">
                    <i className="ri-hd-line text-accent-400 text-sm"></i>
                  </div>
                  <span className="text-xs md:text-sm">全高清画质</span>
                </div>
                <div className="flex items-center gap-2 text-background-50/80">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-500/20 rounded-lg">
                    <i className="ri-shield-check-line text-green-400 text-sm"></i>
                  </div>
                  <span className="text-xs md:text-sm">安全无广告</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#media"
                  className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap text-center"
                >
                  <i className="ri-play-circle-line mr-2"></i>
                  立即观影
                </a>
                <a
                  href="#cards"
                  className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 hover:bg-background-50/20 border border-background-50/20 text-background-50 font-medium rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap text-center"
                >
                  <i className="ri-fire-line mr-2"></i>
                  热播推荐
                </a>
              </div>
            </div>

            <div className="flex-1 w-full max-w-[480px] lg:max-w-none animate-slide-in-right">
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-r from-primary-500/20 via-accent-500/20 to-primary-500/20 rounded-2xl blur-2xl"></div>
                <div className="relative grid grid-cols-2 gap-3">
                  <div className="space-y-3">
                    <div className="rounded-xl overflow-hidden aspect-[2/3] bg-foreground-800">
                      <img
                        src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20amber%20tones%2C%20film%20cell%20aesthetic%2C%20soft%20atmospheric%20glow%2C%20cinematic%20composition%2C%20dark%20background%20with%20warm%20highlights%2C%20elegant%20theater%20vibe&width=400&height=600&seq=mahua-hero-thumb-01&orientation=portrait"
                        alt="热门电影推荐"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="rounded-xl overflow-hidden aspect-[2/3] bg-foreground-800">
                      <img
                        src="https://readdy.ai/api/search-image?query=TV%20drama%20poster%20aesthetic%20with%20warm%20cinematic%20tones%2C%20soft%20dramatic%20lighting%2C%20emotional%20atmosphere%2C%20golden%20hour%20warmth%2C%20film%20grain%20texture%2C%20artistic%20composition%2C%20dark%20background%20accents&width=400&height=600&seq=mahua-hero-thumb-02&orientation=portrait"
                        alt="热门电视剧推荐"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                  <div className="space-y-3 pt-6">
                    <div className="rounded-xl overflow-hidden aspect-[2/3] bg-foreground-800">
                      <img
                        src="https://readdy.ai/api/search-image?query=Variety%20show%20entertainment%20poster%20with%20bright%20warm%20stage%20lighting%2C%20dynamic%20colorful%20atmosphere%2C%20joyful%20cinematic%20vibe%2C%20golden%20and%20amber%20highlights%2C%20show%20production%20aesthetic%2C%20dark%20background%20contrast&width=400&height=600&seq=mahua-hero-thumb-03&orientation=portrait"
                        alt="热门综艺推荐"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="rounded-xl overflow-hidden aspect-[2/3] bg-foreground-800">
                      <img
                        src="https://readdy.ai/api/search-image?query=Classic%20film%20poster%20with%20nostalgic%20cinematic%20aesthetic%2C%20warm%20sepia%20and%20golden%20tones%2C%20vintage%20movie%20atmosphere%2C%20soft%20theater%20lighting%2C%20elegant%20composition%2C%20dark%20background%20with%20warm%20accents&width=400&height=600&seq=mahua-hero-thumb-04&orientation=portrait"
                        alt="经典电影推荐"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}